import { useEffect } from 'react';
import { createPortal } from 'react-dom';

function getPortalRoot() {
  return document.getElementById('modal-portal-root') || document.body;
}

/**
 * Backdrop для модальных окон.
 * Закрытие: клик по области вокруг панели (onClose / onClick) или Escape.
 */
export default function ModalOverlay({ children, className = '', onClick, onClose, zIndex = 50 }) {
  const close = onClose || onClick;

  useEffect(() => {
    if (!close) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') close();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [close]);

  const handleBackdropClick = (e) => {
    if (e.target !== e.currentTarget) return;
    close?.();
  };

  return createPortal(
    <div
      className={`fixed inset-0 modal-overlay flex items-center justify-center p-4 ${className}`.trim()}
      style={{ zIndex }}
      onClick={handleBackdropClick}
      role="presentation"
    >
      {children}
    </div>,
    getPortalRoot()
  );
}
